export default __webpack_public_path__ + "static/media/33_thumbnail.c88d1750.JPG";